import { ObservableInput, ObservedValueOf, OperatorFunction, map, of, switchMap } from "rxjs";

//should probably be called opMap like optional chaining ?. operator
export function traverse<T,R>(project:(value:T, index:number)=>R):OperatorFunction<T,R|undefined|null>{
	return map((input:T, index:number):R|undefined|null=>{
		if(input===undefined)
			return undefined;
		if(input===null)
			return null;
		return project(input,index);
	});
}

export function traverse$<T,O extends ObservableInput<any>>(f:(value:T)=>O):OperatorFunction<T, ObservedValueOf<O>>{
	return switchMap<T,O>(
		(input:T):O=>{
			if(input===undefined)
				return <O>of(undefined);
			if(input===null)
				return <O>of(null);
			const next=f(input);
			if(next===undefined)
				return <O>of(undefined);
			if(next===null)
				return <O>of(null);
			return next;
		}
	);
}
